import { FireIcon } from "@heroicons/react/24/solid";
import { ButtonBase, Grid, Link, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";
import Color from "../../../assets/colors";

// Grid Components //
export const ParentContainer = styling(Grid)((props) => ({
  paddingInline: "100px",
  paddingBlock: "80px",

  [props.theme.breakpoints.down("tabletL")]: {
    paddingInline: "1.5rem",
  },

  [props.theme.breakpoints.down(780)]: {
    paddingBlock: "2.5rem",
  },
}));

export const FlexContainerStyled = styling(Grid)((props) => ({
  display: "flex",
  padding: "2.5rem",
  maxWidth: "1240px",
  width: "100%",
  margin: "auto",
  borderRadius: "26px",
  border: `6px solid ${Color.buttonGrey}`,
  columnGap: "1.5rem",
  position: "relative",

  [props.theme.breakpoints.down(1280)]: {
    maxWidth: "1080px",
  },

  [props.theme.breakpoints.down("tabletL")]: {
    padding: "1.5rem 2rem",
  },

  [props.theme.breakpoints.down(780)]: {
    flexDirection: "column",
    paddingInline: "1.5rem",
    rowGap: "0.5rem",
  },
}));

export const TextGridContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  justifyContent: "center",

  [props.theme.breakpoints.down(1280)]: {
    justifyContent: "flex-start",
    position: "relative",
  },

  [props.theme.breakpoints.down("tabletL")]: {
    justifyContent: "center",
  },
}));

export const LinkGridContainer = styling(Grid)((props) => ({
  display: "flex",
  width: "100%",
  justifyContent: "left",
  alignItems: "center",
  gap: "32px",

  [props.theme.breakpoints.down(780)]: {
    flexDirection: "column",
    alignItems: "center",
    rowGap: "24px",
  },
}));

export const TitleContainer = styling(Grid)((props) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
}));

export const ImageContainer = styling(Grid)((props) => ({
  display: "grid",
  placeItems: "center",
  position: "relative",
}));

// Typography Components //
export const TitleStyled = styling(Typography)((props) => ({
  fontWeight: 400,

  ...(props.variant === "title" && {
    fontSize: "2.5rem",
    fontFamily: "Georgia",
    lineHeight: "120%",
    color: Color.buttonGrey,
    marginBottom: "1.5rem",
  }),

  ...(props.variant === "description" && {
    fontSize: "1.5rem",
    fontFamily: "Inter",
    lineHeight: "150%",
    letterSpacing: "0.15px",
    color: Color.textMediumEmphasis,
    marginBottom: "2.5rem",
  }),

  [props.theme.breakpoints.down("tabletL")]: {
    ...(props.variant === "title" && {
      fontSize: "1.5rem",
    }),

    ...(props.variant === "description" && {
      fontSize: "1rem",
    }),
  },

  [props.theme.breakpoints.down(780)]: {
    ...(props.variant === "description" && {
      marginBottom: "1.5rem",
    }),
  },
}));

// Link Components //
export const LinkStyled = styling(Link)((props) => ({
  color: Color.blue,
  fontFamily: "Inter",
  fontSize: "20px",
  fontWeight: 700,
  lineHeight: "150%",
  letterSpacing: "0.15px",
  textDecoration: `underline ${Color.blue}`,
  textTransform: "capitalize",

  "&:hover": {
    color: Color.blue,
  },

  [props.theme.breakpoints.down("tabletL")]: {
    fontSize: "16px",
  },
}));

// Button Components //
export const ButtonStyled = styling(ButtonBase)((props) => ({
  width: "240px",
  height: "56px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "0.75rem 1.5rem",
  borderRadius: "100px",
  background: Color.buttonGrey,
  boxShadow: `0 2px 4px 0px rgba(104, 77, 0, 0.40)`,
  color: Color.white,
  fontFamily: "Inter",
  fontWeight: 700,
  lineHeight: "1.5rem",
  fontSize: "1.25rem",
  textTransform: "capitalize",

  [props.theme.breakpoints.down(780)]: {
    width: "100%",
  },
}));

// Image Components //
export const WorkCultureReportImage = styling("img")((props) => ({
  objectFit: "contain",
  width: "280px",
  height: "325px",
}));

// Icon Components //
export const FlameIcon = styling(FireIcon)((props) => ({
  color: "#FFDA07",
  width: "34px",
  height: "37px",
  position: "absolute",
  top: "1.25rem",
  right: "2.5rem",

  [props.theme.breakpoints.down(1280)]: {
    top: "0",
    right: "0",
  },
}));
